<div>
  <img class="traffic-light" alt="{{filename}}" src="../assets/{{filename}}.svg" >

</div>

